const sanitizeDateResponse = (date: string): number =>
  parseInt(date.replace('/Date(', '').replace(')/', ''), 10);

export default sanitizeDateResponse;
